import { Injectable, Injector } from '@angular/core';

import {
    PermissionCheckerService,
    NotifyService,
    SettingService,
} from 'abp-ng2-module';

import {
    VDBServiceProxy,
    PagedResultDtoOfVirtualDbRowDto
} from '@shared/service-proxies/service-proxies';
import {  tap } from 'rxjs/operators';
import * as _ from 'lodash-es';

import { Observable } from 'rxjs';
import { AppSessionService } from '@axilla/axilla-shared';

@Injectable({
    providedIn: 'root',
})
export class OrderService {
    notify: NotifyService;
    setting: SettingService;
    appSession: AppSessionService;

    IsShowAvailableStockInfoEnabled: boolean;

    constructor(injector: Injector,
        private _permissionCheckerService: PermissionCheckerService,
        private _sessionService: AppSessionService,

        public _vdbService: VDBServiceProxy
    ) {
        this.notify = injector.get(NotifyService);
        this.setting = injector.get(SettingService);
        this.appSession = injector.get(AppSessionService);
    }


    getDataFromVdb$(orderId: string, vdbName: string): Observable<PagedResultDtoOfVirtualDbRowDto> {
        return this._vdbService.getSearchVirtualDbRowsAsObject(
            orderId,
            vdbName,
            undefined,
            undefined,
            undefined,
            true,
            undefined,
            0,
            1000)
            .pipe(
                tap((result: PagedResultDtoOfVirtualDbRowDto) => {

                })
            );
    }

}
